import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { getList } from "actions/chargers/rent/actions";
import { openCustomModal, closeCustomModal } from "views/lib/components/modals";

import CommonTable from "views/lib/components/CommonTable";

import Filers from "./filters";

const PowerBankRent = ({
                         list,
                         getList,
                       }) => {
  const getColumns = () => [
    {
      id: "id",
      Header: "ID",
      accessor: "id",
    },
    {
      id: "user",
      Header: "User",
      accessor: "user",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => {
        if (original.user) {
          return (
            <Link to={`/users/${original.user}`}>
              {original.user}
            </Link>
          );
        }
        return null;
      }
    },
    {
      id: "powerBank",
      Header: "Power bank",
      accessor: "powerBank"
    },
    {
      id: "startStationQR",
      Header: "Start Station QR",
      accessor: "startStationQR",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/chargers/stations/list/${original.startStationQR}`}>
          {original.startStationQR}
        </Link>
      ),
    },
    {
      id: "endStationQR",
      Header: "End Station QR",
      accessor: "endStationQR",
      // eslint-disable-next-line react/display-name
      Cell: ({ original }) => (
        <Link to={`/chargers/stations/list/${original.endStationQR}`}>
          {original.endStationQR}
        </Link>
      ),
    },
    {
      id: "stationType",
      Header: "Station Type",
      accessor: "stationType",
    },
    {
      id: "scan",
      Header: "Scan",
      Cell: ({ original }) => moment(original.scan)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "start",
      Header: "Start",
      Cell: ({ original }) => moment(original.start)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "end",
      Header: "End",
      Cell: ({ original }) => moment(original.end)
        .format("HH:mm YYYY-MM-DD"),
    },
    {
      id: "payment.amount",
      Header: "Amount",
      accessor: "payment.amount",
    },
    {
      id: "payment.amount",
      Header: "Billing Amount",
      accessor: "payment.billingAmount",
    },
    {
      id: "payment.status",
      Header: "Payment status",
      accessor: "payment.status",
    },
  ];

  return (
    <CommonTable
      columns={getColumns()}
      list={list}
      getListFunction={getList}
      FiltersComponent={Filers}
      searchHookProps={{
        size: 20,
        sort: "date,desc"
      }}
    />
  );
};

const mapStateToProps = state => ({
  list: state.powerBankRent.list,
});

const mapStateToDispatch = dispatch => ({
  openCustomModal: bindActionCreators(openCustomModal, dispatch),
  closeCustomModal: bindActionCreators(closeCustomModal, dispatch),

  getList: bindActionCreators(getList, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(PowerBankRent);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/rent/index.js